import { Text, Card, CardHeader, CardFooter, CounterBadge } from "@fluentui/react-components";
import { Tag } from "@fluentui/react-components";
import { IToDoProps } from "../../../hooks/types";
import { Open16Regular, Calendar20Regular, CalendarError16Regular } from "@fluentui/react-icons";
import { _blank } from "../../../utility/app-constants";
import { toDosConstants } from "../../../utility/app-constants";

/**
 * To display all the to-dos items in a card
 * @param props 
 * @returns 
 */
export default function TodosCard(props: IToDoProps) {

    return (
        <div className="todo-card-main">
            <CounterBadge className="todo-badge" appearance="filled" color="danger" count={1} style={{ display: props?.counterBadge ? "inline" : "none" }} />
            <Card
                className="todo-card"
                onClick={() => window.open(props?.link, _blank)}
                data-testid="to-dos-card" 
            >
                <CardHeader
                    className="todo-card-header-main"
                    header={
                        <Text className="todo-card-header" weight="semibold">
                            {props?.title}
                        </Text>
                    }
                    description={
                        props?.deadlineDate && (
                            <Tag
                                style={props?.urgentDeadline ? { backgroundColor: "#FFEFD2" } : { backgroundColor: "#C2D9FE" }}
                                className="duedate-tag"
                                icon={props?.urgentDeadline ? <CalendarError16Regular className="calender-icon" /> : <Calendar20Regular className="calender-icon" />}
                            >
                                <div className="due-date">
                                    <p><span className="due-text">{toDosConstants.due}</span>{props?.deadlineDate}</p>
                                </div>
                            </Tag>
                        )
                    }
                />
                        <CardFooter className="footer-container" data-testid="to-dos-card-hover-link">
                            <Text className="todo-card-footer" data-testid="to-dos-card-hover-link-txt">
                                {toDosConstants.siteLink}
                            </Text>
                            <Open16Regular className="todo-share-img" />
                        </CardFooter>
            </Card>
        </div>
    );
}
